import { api } from '../api';

export interface BlogPostPreview {
  is_archive?: boolean;
  source_date?: string | null;
  updated_at?: string;
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  image_url: string | null;
  tags: string[];
  meta_description: string | null;
  published_at: string;
  created_at: string;
  view_count: number;
  reading_time: number;
}

export interface BlogPostFull extends BlogPostPreview {
  content: string;
  meta_title: string | null;
  related: BlogPostPreview[];
}

export interface BlogListResponse {
  data: BlogPostPreview[];
  total: number;
  page: number;
  limit: number;
  total_pages: number;
}

export const blogApi = {
  getList: async (page = 1, limit = 12, tag?: string): Promise<BlogListResponse> => {
    const params: Record<string, string | number> = { page, limit };
    if (tag) params.tag = tag;
    const response = await api.get<BlogListResponse>('/blog', { params });
    return response.data;
  },

  getBySlug: async (slug: string): Promise<BlogPostFull> => {
    const response = await api.get<BlogPostFull>(`/blog/${slug}`);
    return response.data;
  },

  getTags: async (): Promise<string[]> => {
    const response = await api.get<string[]>('/blog/tags');
    return response.data;
  },
};
